import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

/** Cores pre-definidas para status conhecidos */
const STATUS_COLORS: Record<string, string> = {
  Efetivado: '#217B00',
  Agendado: '#007AF0',
  'Em Fila': '#E76F00',
  Cancelado: '#D01E29',
  Faltou: '#999999',
  Recepcionado: '#02786D',
};

/** Paleta fallback para status desconhecidos */
const FALLBACK_PALETTE = [
  '#007AF0', '#217B00', '#E76F00', '#D01E29', '#02786D',
  '#6a1b9a', '#795548', '#00838f', '#455a64', '#c62828',
];

interface StatusDonutItem {
  name: string;
  value: number;
  color?: string;
}

interface StatusDonutProps {
  data: StatusDonutItem[];
  titulo?: string;
}

const StatusDonut: React.FC<StatusDonutProps> = ({ data, titulo }) => {
  const theme = useTheme();

  const resolveColor = (item: StatusDonutItem, index: number): string => {
    if (item.color) return item.color;
    if (STATUS_COLORS[item.name]) return STATUS_COLORS[item.name];
    return FALLBACK_PALETTE[index % FALLBACK_PALETTE.length];
  };

  if (!data.length) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body2" color="text.secondary">
          Sem dados para exibir.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {titulo && (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {titulo}
        </Typography>
      )}

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius="60%"
            outerRadius="80%"
            paddingAngle={2}
            strokeWidth={0}
          >
            {data.map((item, idx) => (
              <Cell key={item.name} fill={resolveColor(item, idx)} />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: `1px solid ${theme.palette.divider}`,
              fontSize: 12,
            }}
            formatter={(value: any, name: any) => [
              Number(value).toLocaleString('pt-BR'),
              String(name),
            ]}
          />
          <Legend
            verticalAlign="bottom"
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
          />
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StatusDonut;
